import { useEffect, useRef } from 'react';
import { subscribeAppForeground } from 'src/modules/appLifecycle';

type Options = { isEnabled?: boolean; isVisibilityIncluded?: boolean };

export const useAppForeground = (
  onForeground: () => void,
  { isEnabled = true, isVisibilityIncluded = false }: Options = {},
) => {
  const onForegroundRef = useRef(onForeground);

  useEffect(() => {
    onForegroundRef.current = onForeground;
  });

  useEffect(() => {
    if (!isEnabled) return;
    return subscribeAppForeground(() => onForegroundRef.current(), {
      isVisibilityIncluded,
    });
  }, [isEnabled, isVisibilityIncluded]);
};
